export const CONFIG_VERSION = "v1";
export const BAD_INDEX = -1;

export const APP_NAME = {
    IFRAME: 'iframe',
    CRYOLAB: 'cryolab',
    MARKEN: 'marken',
    END_TO_END: 'end-to-end'
}
